<div class="bg-white min-h-full p-0">
	<div class="profile-cover pt-5">
		<div class="cursor-pointer flex flex-row items-left h-6">
			<div (click)="onClickBack()"
				class="flex flex-row justify-center items-center ml-2 text-lg align-middle font-normal text-white bg-black/50 rounded pr-2 py-4">
				<mat-icon class="text-white text-lg w-7 h-7" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
				Back
			</div>
		</div>
	</div>
	<div class="rounded-3xl shadow-md bg-profile-content">
		<div class="px-3 flex">
			<div class="flex-1 relative">
				<img [routerLink]="RoutingConstant.PROFILE_DETAIL"
					class="img-profile shadow-md border-4 border-slate-50" src="{{
						profileDetail.photoURL || 'assets/images/default_profile_picture.png'
					}}" alt="logo wacaku" />
				<!-- <img
					class="absolute -top-[47px] -left-[6px] h-[116px] w-[108px]"
					src="{{ 'assets/background/halloween-frame.png' }}"
					alt="logo wacaku" /> -->
			</div>
			<div class="gap-1.5 flex justify-center items-center mt-2">
				<!--Coin-->
				<app-user-waca-koin (click)="goToTopup()" [isShowLabel]="false"></app-user-waca-koin>
				<!--Action settings-->
				<div class="w-12 h-12 p-1 cursor-pointer flex items-center justify-center bg-black rounded-md"
					[routerLink]="[RoutingConstant.CONFIGURATION]">
					<img src="../../../../../assets/icons/icon-setting.svg" class="w-5" alt="" />
				</div>
			</div>
		</div>

		<!--User info-->
		<div class="pl-6 mt-4 pr-4">
			<div class="role">
				{{ publishedPost.length > 0 ? 'Penulis' : 'Pembaca' }}
			</div>
			<div class="title-user leading-snug flex items-center gap-2">
				<div>{{ profileDetail.fullName }}</div>
				<img
				  *ngIf="profileDetail.isBadgeVerified === true"
				  [src]="badgeUrl"
				  alt="Badge"
				  class="w-5 h-5"
				/>
			</div>
			<div class="title-username">@{{ profileDetail.username }}</div>
			<div class="description-user">
				{{ profileDetail.biography || '' }}
			</div>
		</div>

		<!--Badge-->
		<div class="container-list-info">
			<div class="cursor-pointer" *ngFor="let item of profileDetail.badges" (click)="detailBadge(item)">
				<img class="logo-item" src="{{ item.badgeUrl }}" alt="" />
			</div>
		</div>

		<hr class="line-space mt-5" />

		<!--Counter-->
		<div class="container-inform-user">
			<div class="flex-1 container-inform-detail">
				<div class="number-title">
					<img src="/assets/gif/heart40.gif" class="w-5" alt="" />
					<div class="ml-3">{{ profileDetail.totalLikes || 0 }}</div>
				</div>
				<div class="label-inform">Karya disukai</div>
			</div>
			<div class="flex-1 container-inform-detail">
				<div class="number-title">
					<div>{{ shortenNumber(profileDetail.totalPostView) || 0 }}</div>
				</div>
				<div class="label-inform">Pembaca</div>
			</div>
			<div class="flex-1 container-inform-detail cursor-pointer"
				(click)="onClickNavigateFollow(followTabEnum.FOLLOWING)">
				<div class="number-title">
					<div>{{ shortenNumber(profileDetail.totalFollowing) || 0 }}</div>
				</div>
				<div class="label-inform">Mengikuti</div>
			</div>
			<div class="flex-1 container-inform-detail cursor-pointer"
				(click)="onClickNavigateFollow(followTabEnum.FOLLOWERS)">
				<div class="number-title">
					<div>{{ shortenNumber(profileDetail.totalFollowers) || 0 }}</div>
				</div>
				<div class="label-inform">Pengikut</div>
			</div>
		</div>
	</div>

	<!--User Collection-->
	<div class="w-full grid grid-cols-3 gap-2 px-5">
		<div *ngFor="let item of tabs" class="tab-header-title cursor-pointer whitespace-nowrap mx-2"
			[ngClass]="item === activeTabs ? 'active-tabs' : ''" (click)="onClickTabs(item)">
			{{ item }}
		</div>
	</div>

	<div class="px-5">
		<!--Published post-->
		<div *ngIf="activeTabs === 'Karya Saya'">
			<div class="grid grid-cols-3 gap-4 py-8">
				<ng-container *ngFor="let post of publishedPost">
					<app-card-book [post]="post"></app-card-book>
				</ng-container>
			</div>
		</div>
		<!--Reading history-->
		<div *ngIf="activeTabs === 'Bacaan'">
			<div class="grid grid-cols-3 gap-4 py-8">
				<ng-container *ngFor="let post of readingHistory">
					<app-card-book [post]="post"></app-card-book>
				</ng-container>
			</div>
		</div>
		<!--Event-->
		<!-- <div *ngIf="activeTabs === 'Event'">
			<div style="margin-top: 30px">
				<app-card-event *ngFor="let item of listEvent" [data]="item"> </app-card-event>
			</div>
		</div> -->
		<!--Bookmark-->
		<div *ngIf="activeTabs === 'Disimpan'">
			<div *ngIf="savedPosts.length" class="grid grid-cols-3 gap-4 py-8">
				<app-card-book *ngFor="let item of savedPosts" [post]="item"></app-card-book>
			</div>
			<div *ngIf="!savedPosts.length" class="grid grid-cols-3 gap-4 py-8">
				<!-- <p>Belum ada karya disimpan</p> -->
			</div>
		</div>
	</div>
</div>